/**
 * Orquestación de batería para candidatos.
 * Obtiene los instrumentos a ejecutar desde la configuración del proceso.
 */

import { normalizeBatteryForDerived, normalizeTestId } from '@/config/batteries';
import { getInstrumentId, normalizeSelectedTests } from '@/config/tests';

export interface BatteryModule {
  instrumentId: string;
  testKey: string;
}

/**
 * Obtiene la lista de instrumentos únicos a ejecutar para un candidato.
 * Usa testKeys del proceso o moduleIds de processBatteries.
 */
export function getInstrumentsToRun(
  processTestKeys: string[],
  batteryModuleIds: string[]
): BatteryModule[] {
  const raw = processTestKeys.length > 0 ? processTestKeys : batteryModuleIds.map(normalizeTestId);
  const normalized = normalizeBatteryForDerived(raw);
  const withCultureFit = normalized.includes('cultura_fit')
    ? normalized
    : [...normalized, 'cultura_fit'];
  const unique = normalizeSelectedTests(withCultureFit);
  const ordered = unique
    .filter((testKey) => testKey !== 'cultura_fit')
    .concat('cultura_fit');

  return ordered.map((testKey) => ({
    instrumentId: getInstrumentId(testKey),
    testKey,
  }));
}
